/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { io } from 'socket.io-client';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  socket: any;
  url: string = '';
  constructor() {}

  initSocket(): void {
    if (
      localStorage.getItem(`${environment.storageKey}`) &&
      localStorage.getItem(`${environment.storageKey}`) !== undefined
    ) {
      const token = localStorage.getItem(`${environment.storageKey}`);
      this.socket = io(environment.socket_url, {
        reconnection: true,
        query: { token,
          issuperadmin: true },
        extraHeaders: { issuperadmin: 'true' }
      });
      // Connection success
      this.socket.on('connect', () => {
        // console.log('[SocketService] ✅ Socket connected:', this.socket.id);
      });
    }
  }

  emitAction(action: any, payload: any): void {
    this.socket.emit(action, payload);
  }

  // public onEvent(event: string): Observable<any> {
  //   console.error(event, 'event-of-socket');

  //   return new Observable<any>(observer => {
  //     this.socket.on(event, (data: any) => {
  //       observer.next(data);
  //     });
  //   });
  // }
  public onEvent(event: string): Observable<any> {
    // console.log(`[SocketService] 👂 Listening for event: "${event}"`);
    return new Observable<any>(observer => {
      this.socket.on(event, (data: any) => {
        // console.log(
        //   `[SocketService] 📥 Event "${event}" received with data:`,
        //   data
        // );
        observer.next(data);
      });
    });
  }

  notificationCount(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket?.on('addSupportTicketSocketUpdated', (data: any) => {
        // console.log(data, 'daat');
        observer.next(data);
      });
      return () => {
        this.socket?.disconnect();
      };
    });
  }

  disconnect(): void {
    this.socket.disconnect();
  }
}
